import { render, staticRenderFns } from "./ProductBrand.vue?vue&type=template&id=692c3bbc&scoped=true"
import script from "./ProductBrand.vue?vue&type=script&lang=js"
export * from "./ProductBrand.vue?vue&type=script&lang=js"
import style0 from "./ProductBrand.vue?vue&type=style&index=0&id=692c3bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692c3bbc",
  null
  
)

export default component.exports